import { fork, take, put } from 'redux-saga/effects';

import * as actions from 'actions';

export function* watchForLocationChange() {
  while(true) { // eslint-disable-line no-constant-condition
    yield take('@@router/LOCATION_CHANGE');
    yield put(actions.infoClose('success'));
  }
}

export default function* backgroundSaga() {
  yield [
    fork(watchForLocationChange)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/info/sagas.js
 **/